



















































































































































































import { AppointmentApi } from '@/api/appointments';
import { UpdateAppointmentOutcomeRequest } from '@/api/requests/appointments/update-appointment-outcome-request';
import { instructionTypeDescription, outcomePaymentStatusTypeDescription, outcomeTypeDescription } from '@/components/appointments/appointment-utilities';
import { Appointment } from '@/shared/appointments/appointment';
import { AppointmentOutcome } from '@/shared/appointments/appointment-outcome';
import { createAppointmentOutcomePaymentDetails } from '@/shared/appointments/appointment-outcome-payment-details';
import { InstructionType } from '@/shared/instruction-type';
import { AppointmentCancellationType } from '@/shared/types/appointment-cancellation-type';
import { AppointmentExecutorType } from '@/shared/types/appointment-executor-type';
import { AppointmentNoInstructionType } from '@/shared/types/appointment-no-instruction-type';
import { AppointmentOutcomeType } from '@/shared/types/appointment-outcome-type';
import { AppointmentPaymentStatusType } from '@/shared/types/appointment-payment-status-type';
import { AppointmentProductType } from '@/shared/types/appointment-product-type';
import { AppointmentType } from '@/shared/types/appointment-type';
import { DateTime } from 'luxon';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const typesModule = namespace('types');
const userModule = namespace('user');
const appointmentApi = new AppointmentApi();

@Component
export default class EditAppointmentOutcomeLegacyDialog extends Vue {
    @typesModule.Getter('appointmentTypes') public appointmentTypes!: Array<AppointmentType>;
    @typesModule.Getter('activeAppointmentNoInstructionTypes') public noInstructionTypes!: Array<AppointmentNoInstructionType>;
    @typesModule.Getter('activeAppointmentCancellationTypes') public cancellationTypes!: Array<AppointmentCancellationType>;
    @typesModule.Getter('activeAppointmentProductTypes') public appointmentProductTypes!: Array<AppointmentProductType>;
    @typesModule.Getter('activeAppointmentOutcomeTypes') public outcomeTypes!: Array<AppointmentOutcomeType>;
    @typesModule.Getter('activeAppointmentExecutorTypes') public professionalExecutorTypes!: Array<AppointmentExecutorType>;
    @typesModule.Getter('activeAppointmentPaymentStatusTypes') public paymentStatusTypes!: Array<AppointmentPaymentStatusType>;

    @userModule.Getter('isInternalKeyStakeholder') public isInternalKeyStakeholder!: boolean;
    @userModule.Getter('isHeadOfDepartment') private isHoD!: boolean;

    @Prop({ required: true }) public appointment!: Appointment;
    @Prop({ required: true }) public visible!: boolean;

    private currentStep: number = 0;
    private saving: boolean = false;
    private isVisible: boolean = this.visible;
    private appointmentOutcome: AppointmentOutcome = {
        ...this.appointment.outcome!,
        paymentDetails: this.appointment.outcome!.paymentDetails == null ? null : { ...this.appointment.outcome!.paymentDetails },
        products: [...this.appointment.outcome!.products],
    };
    private products: Array<AppointmentProductType & { selected: boolean }> = new Array<AppointmentProductType & { selected: boolean }>();

    private get canEditOutcomeType(): boolean {
        return this.isInternalKeyStakeholder;
    }

    private get canEditInstructionType(): boolean {
        if (this.isInternalKeyStakeholder) {
            return true;
        }

        return this.appointment.outcome!.instructionType == null ? false : this.appointment.outcome!.instructionType === InstructionType.CoolingOff || this.appointment.outcome!.instructionType === InstructionType.ConsideringOptions;
    }

    private get canEditInstructedValue(): boolean {
        if (this.isInternalKeyStakeholder) {
            return true;
        }

        if (this.appointment.outcome!.paymentDetails == null) {
            return true;
        }

        const paymentStatusType = this.paymentStatusTypes.find((type) => type.id === this.appointment.outcome!.paymentDetails!.paymentStatusId!);

        return paymentStatusType == null || paymentStatusType.isSigningPending || paymentStatusType.isSigningBooked;
    }

    private get canEditNumberOfPayments(): boolean {
        if (this.isInternalKeyStakeholder) {
            return true;
        }

        if (this.appointment.outcome!.paymentDetails == null) {
            return true;
        }

        const paymentStatusType = this.paymentStatusTypes.find((type) => type.id === this.appointment.outcome!.paymentDetails!.paymentStatusId!);

        return paymentStatusType == null || paymentStatusType.isSigningPending || paymentStatusType.isSigningBooked;
    }

    private get canEditSigningDate(): boolean {
        if (this.isInternalKeyStakeholder) {
            return true;
        }

        if (this.appointment.outcome!.paymentDetails == null) {
            return true;
        }

        const paymentStatusType = this.paymentStatusTypes.find((type) => type.id === this.appointment.outcome!.paymentDetails!.paymentStatusId!);

        return paymentStatusType == null || paymentStatusType.isSigningPending || paymentStatusType.isSigningBooked || paymentStatusType.isDebtor || paymentStatusType.isNoLongerProceeding;
    }

    private get outcomeTypeDescription(): string {
        return outcomeTypeDescription(this.appointmentOutcome.outcomeTypeId);
    }

    private get instructionTypeDescription(): string {
        return instructionTypeDescription(this.appointmentOutcome.instructionType!);
    }

    private get outcomePaymentStatusTypeDescription(): string {
        return outcomePaymentStatusTypeDescription(this.appointmentOutcome.paymentDetails!.paymentStatusId!);
    }

    private get signingStartDate(): Date {
        return new Date(this.appointment.date!.toString());
    }

    private get validateAfterAppointmentDate(): string {
        const start = DateTime.fromJSDate(this.signingStartDate).minus({ days: 1 }).toFormat('dd/MM/yyyy');
        return `${start}`;
    }

    private get showSigningDate(): boolean {
        if (this.appointmentOutcome!.paymentDetails == null || this.appointmentOutcome!.paymentDetails!.paymentStatusId == null) {
            return false;
        }

        const paymentStatusType = this.paymentStatusTypes.find((type) => type.id === this.appointmentOutcome!.paymentDetails!.paymentStatusId!);
        return paymentStatusType == null ? false : paymentStatusType.isSigningBooked;
    }

    private get showNumberOfPayments(): boolean {
        if (this.appointmentOutcome!.paymentDetails == null || this.appointmentOutcome!.paymentDetails!.paymentStatusId == null) {
            return false;
        }

        const paymentStatusType = this.paymentStatusTypes.find((type) => type.id === this.appointmentOutcome!.paymentDetails!.paymentStatusId!);
        return paymentStatusType == null ? false : paymentStatusType.isPartPayment;
    }

    private get paymentStatuses(): Array<AppointmentPaymentStatusType> {
        if (this.isInternalKeyStakeholder || this.isHoD) {
            return this.paymentStatusTypes.filter((type) => !type.isArchived);
        }

        return this.paymentStatusTypes.filter((type) => !type.isArchived && !type.isAdminOnly);
    }

    private get instructionTypes(): Array<{ id: InstructionType, value: string }> {
        return new Array<{ id: InstructionType, value: string }>(...[
            { id: InstructionType.NotInstructed, value: 'Not Instructed' },
            { id: InstructionType.CoolingOff, value: '14 Day Cooling Off Period' },
            { id: InstructionType.ConsideringOptions, value: 'Considering Options' },
            { id: InstructionType.Instructed, value: 'Instructed' },
        ]);
    }

    private get maxSteps(): number {
        let steps = 0;

        if (this.showProductsSold) {
            steps++;
        }

        if (this.showPaymentTab) {
            steps += 2;
        }

        return steps;
    }

    private get isInstructedAsYes(): boolean {
        return this.appointmentOutcome.instructionType === InstructionType.Instructed;
    }

    private get isNotSat(): boolean {
        const outcomeType = this.outcomeTypes.find((type) => type.id === this.appointmentOutcome.outcomeTypeId);
        return outcomeType == null ? true : outcomeType.isNotSat;
    }

    private get isCancelled(): boolean {
        const outcomeType = this.outcomeTypes.find((type) => type.id === this.appointmentOutcome.outcomeTypeId);
        return outcomeType == null ? false : outcomeType.isCancelled;
    }

    public get isInitialAppointment(): boolean {
        if (this.appointment.appointmentTypeId == null) {
            return false;
        }

        const appointmentType = this.appointmentTypes.find((type) => type.id === this.appointment.appointmentTypeId);
        return appointmentType == null ? false : appointmentType.isInitialAppointment;
    }

    public get showProductsSold(): boolean {
        const outcomeType = this.outcomeTypes.find((type) => type.id === this.appointmentOutcome.outcomeTypeId!);
        return outcomeType == null ? false : this.isInitialAppointment && outcomeType.isSat && this.appointmentOutcome.instructionType === InstructionType.Instructed;
    }

    private get showPaymentTab(): boolean {
        const outcomeType = this.outcomeTypes.find((type) => type.id === this.appointmentOutcome.outcomeTypeId!);
        return outcomeType == null ? false : this.isInstructedAsYes;
    }

    @Watch('visible')
    private onVisibleChanged(visible: boolean): void {
        this.$validator.errors.clear();
        this.isVisible = visible;
    }

    @Watch('appointmentOutcome.outcomeTypeId')
    private onOutcomeTypeChanged(): void {
        const outcomeType = this.outcomeTypes.find((type) => type.id === this.appointmentOutcome.outcomeTypeId);

        this.appointmentOutcome.instructionType = outcomeType != null && outcomeType.isSat ? InstructionType.NotInstructed : null;
        this.appointmentOutcome.cancellationTypeId = null;
        this.appointmentOutcome.noInstructionTypeId = null;
        this.appointmentOutcome.noInstructionNotes = null;
        this.appointmentOutcome.estimatedEstateValue = null;
        this.appointmentOutcome.executorTypeId = null;
        this.appointmentOutcome.paymentDetails = null;

        for (const product of this.products) {
            product.selected = false;
        }
    }

    @Watch('appointmentOutcome.instructionType')
    private onInstructionTypeChanged(instructionType: InstructionType): void {
        this.appointmentOutcome.noInstructionTypeId = null;
        this.appointmentOutcome.noInstructionNotes = null;
        this.appointmentOutcome.estimatedEstateValue = null;
        this.appointmentOutcome.executorTypeId = null;
        this.appointmentOutcome.paymentDetails = instructionType === InstructionType.Instructed ? createAppointmentOutcomePaymentDetails() : null;

        for (const product of this.products) {
            product.selected = false;
        }
    }

    @Watch('appointmentOutcome.paymentDetails.paymentStatusId')
    private onPaymentStatusChanged(id: string | null): void {
        if (id == null) {
            this.appointmentOutcome.paymentDetails!.signingDate = null;
        }

        const paymentStatus = this.paymentStatuses.find((type) => type.id === id);

        if (paymentStatus == null || (!paymentStatus.isDebtor && !paymentStatus.isNoLongerProceeding)) {
            this.appointmentOutcome.paymentDetails!.signingDate = null;
        }
    }

    private canEditProduct(product: AppointmentProductType & { selected: boolean }): boolean {
        if (this.isInternalKeyStakeholder) {
            return true;
        }

        if (this.appointment.outcome!.paymentDetails == null) {
            return true;
        }

        const paymentStatus = this.paymentStatuses.find((type) => type.id === this.appointment.outcome!.paymentDetails!.paymentStatusId!);

        if (paymentStatus == null) {
            return true;
        }

        if (!paymentStatus.isSigningPending && !paymentStatus.isSigningBooked) {
            return false;
        }

        const originalProduct = this.appointment.outcome!.products.find((p) => p.productTypeId === product.id);

        return originalProduct == null;
    }

    private async onSave(): Promise<void> {
        const isValid = await this.$validator.validateAll();

        if (!isValid) {
            return;
        }

        this.saving = true;

        try {
            const request: UpdateAppointmentOutcomeRequest = {
                ...this.appointmentOutcome,
                outcomeTypeId: this.appointmentOutcome.outcomeTypeId!,
                paymentDetails: this.appointmentOutcome.paymentDetails == null ? null : { ...this.appointmentOutcome.paymentDetails },
                products: this.products.filter((p) => p.selected).map((p) => {
                    return {
                        productTypeId: p.id!,
                        instructedDate: null,
                        instructedValue: null,
                        instructionType: null,
                        albReference: null,
                        paymentDetails: [],
                    };
                }),
                version: this.appointmentOutcome.version!,
            };

            await appointmentApi.updateAppointmentOutcomeAsync(this.appointment.id!, this.appointment.outcome!.id!, request);
            this.$emit('ok', { ...this.appointmentOutcome });
        } catch (exception) {
            this.$snackbar.open({ message: 'Could not update appointment, please try again.', type: 'is-danger' });
        }

        this.saving = false;
    }

    private async onNext(): Promise<void> {
        const isValid = await this.$validator.validateAll();

        if (!isValid) {
            return;
        }

        setTimeout(() => {
            this.currentStep++;
        }, 0);
    }

    private onPrevious(): void {
        this.currentStep--;
    }

    private onCancel(): void {
        this.$emit('cancel');
    }

    private populateProducts(): Array<AppointmentProductType & { selected: boolean }> {
        const results = new Array<AppointmentProductType & { selected: boolean }>();

        for (const productType of this.appointmentProductTypes) {
            const select = this.appointmentOutcome!.products.some((p) => p.productTypeId === productType.id);

            if (select || !productType.isArchived) {
                results.push({ ...productType, selected: select });
            }
        }

        return results;
    }

    private async mounted(): Promise<void> {
        const types = [
            this.$store.dispatch(`types/loadTypesAsync`),
        ];

        await Promise.all(types);

        this.products = this.populateProducts();
    }
}
